import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, UrlHandlingStrategy, UrlTree } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';  // 👈
import { routes } from './app.routes';
import { ToastrModule, provideToastr } from 'ngx-toastr';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { NzConfig, NZ_CONFIG } from 'ng-zorro-antd/core/config';
import { URLConfig } from '../configs/url-config';
import { FacebookLoginProvider, GoogleLoginProvider, SOCIAL_AUTH_CONFIG, SocialAuthServiceConfig, SocialLoginModule } from '@abacritt/angularx-social-login';
import { apiInterceptor } from './core/interceptors/api.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { CookieServiceWrapper } from './core/services/cookie.service';

const ngZorroConfig: NzConfig = {
  message: { nzTop: 20, nzPauseOnHover: true },
  notification: { nzTop: 240 }
};

export class AlwaysReloadUrlHandlingStrategy implements UrlHandlingStrategy {
  shouldProcessUrl(url: UrlTree): boolean {
    return true;
  }
  extract(url: UrlTree): UrlTree {
    return url;
  }
  merge(newUrlPart: UrlTree, rawUrl: UrlTree): UrlTree {
    return newUrlPart;
  }
}
const googleLoginOptions = {
  scope: "profile email",
  plugin_name: "sample_login" 
};
const FBLoginOptions = {
  Permissions: "public_profile",
  Products: "Facebook Login"
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideToastr(),
    provideHttpClient(
      withInterceptors([apiInterceptor, errorInterceptor])
    ),
    importProvidersFrom(
      ClipboardModule,
      ToastrModule.forRoot(),
      SocialLoginModule
    ),
    URLConfig,
    CookieServiceWrapper,
    { provide: NZ_I18N, useValue: en_US },
    { provide: NZ_CONFIG, useValue: ngZorroConfig },
    {
      provide: SOCIAL_AUTH_CONFIG,
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider("1469979723857646",FBLoginOptions)
          },
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              "49260394315-ess1pbe1mmj1ta9q2q33cmsp75tp1dp2.apps.googleusercontent.com",
              googleLoginOptions
            )
          },
          
        ]
      } as SocialAuthServiceConfig
    },
    { provide: UrlHandlingStrategy, useClass: AlwaysReloadUrlHandlingStrategy },
  ],
};
